<form
  class="promote-to-admin-form"
  [formGroup]="promoteToAdminForm"
  (ngSubmit)="onSubmit()"
>
  <label for="userId">user id: </label>
  <input id="userId" type="text" formControlName="userId" required/>
  <button type="submit">Submit</button>
</form>
